<template lang="pug">
  #signUpIndex.d-flex.flex-column(
    style="height: calc(100% - 120px)"
  )
    .container-width.w-100(
      style="padding-bottom: 20px;flex: 1 1 0;",
    )
      #step1(v-if="nowStep == 1")
        .mb-4.text-center.p-3(
          style="margin-top: 100px;"
        )
          p.font-weight-bold.mb-0 TIFFANY & CO. Taiwan
          p.font-weight-bold.mb-0 LINE官方帳號
          p.font-weight-bold.mb-0 銷售CA綁定服務
        hr.border-primary.border-width-lg.w-100
        .mb-4.text-center.p-3
          p.mb-0 本服務限於TIFFANY & CO. 員工使用
      #step2(v-if="nowStep == 2")
        p.mb-0.text-center.py-3.letter-spacing-6 輸入個人資料
        hr.border-primary.border-width-lg.w-100
        small.mb-0.text-center.d-block.text-muted 請輸入姓名、行動電話及員工編號以完成設定
        b-card.border-0.mb-2(
          bg-variant="white"
        )
          ValidationObserver(
            ref="userForm"
            tag="form"
            @submit.stop.prevent="submitHandler"
          )
            b-form-group(
              class="mb-0"
            )
              ValidationProvider(
                rules="required",
                ref="inputValSaName"
              )
                .row.justify-content-center.mb-4
                  .col-8
                    b-form-input(
                      id="sa_name",
                      type="text",
                      required,
                      trim,
                      :state="validState('sa_name')",
                      v-model="userForm.sa_name",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="姓名",
                      class="rounded-0 bg-light border-black text-center"
                    )
                    b-form-invalid-feedback(
                      id="input-name-live-feedback"
                    )
                      span 此欄不可為空
            b-form-group(
              class="mb-0"
            )
              ValidationProvider(
                rules="required|mobile",
                ref="inputValMobile",
                v-slot="{ errors }"
              )
                .row.justify-content-center.mb-4
                  .col-8
                    b-form-input(
                      id="mobile",
                      type="tel",
                      required,
                      trim,
                      :state="validState('mobile')",
                      v-model="userForm.mobile",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="行動電話",
                      class="rounded-0 bg-light border-black text-center"
                    )
                    b-form-invalid-feedback(
                      id="input-name-live-feedback"
                    )
                      span {{ errors[0] }}
            b-form-group(
              class="mb-0"
            )
              ValidationProvider(
                rules="required",
                ref="inputValSaCode"
              )
                .row.justify-content-center.mb-4
                  .col-8
                    b-form-input(
                      id="code",
                      type="text",
                      required,
                      trim,
                      :state="validState('saCode')",
                      v-model="userForm.saCode",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="員工編號",
                      class="rounded-0 bg-light border-black text-center"
                    )
                    b-form-invalid-feedback(
                      id="input-name-live-feedback"
                    )
                      span 此欄不可為空
            b-form-group(
              class="mb-0"
            )
              ValidationProvider(
                rules="required|verify",
                ref="inputValVerify",
                v-slot="{ errors }"
              )
                .row.justify-content-center.mb-4
                  .col-8
                    .row.no-gutters
                      .col-md-8.col-6.pr-1.d-flex.align-items-center.flex-wrap
                        b-form-input.w-100(
                          id="verify",
                          type="text",
                          required,
                          trim,
                          :state="validState('verify')",
                          v-model="userForm.verify",
                          aria-describedby="input-live-help input-name-live-feedback",
                          placeholder="輸入驗證碼",
                          class="rounded-0 bg-light border-black text-center"
                        )
                        b-form-invalid-feedback.w-100(
                          id="input-name-live-feedback"
                        )
                          span {{ errors.length === 0 ? '驗證碼錯誤' : errors[0] }}
                      .col-md-4.col-6.pl-1
                        .d-flex.align-items-center.justify-content-between
                          VerifyComponent(
                            ref="VerifyComponent"
                          )
                          i.fas.fa-sync-alt.fa-lg(
                            @click="changeVerifyCodeHandler"
                          )
      #step3(v-if="nowStep == 3")
        p.mb-0.text-center.py-3.letter-spacing-6 請輸入發送至您手機之驗證碼
        hr.border-primary.border-width-lg.w-100
        b-card.border-0.mb-2(
          bg-variant="white"
        )
          ValidationObserver(
            ref="mobileVerfityForm"
            tag="form"
            @submit.stop.prevent="mobileVerfityHandler"
          )
            b-form-group.mb-0
              ValidationProvider(
                rules="required",
                ref="inputValMobileVerfity"
              )
                .row.justify-content-center.mb-4
                  .col-8
                    .row.no-gutters
                      b-form-input(
                        id="mobileVerfity",
                        type="text",
                        required,
                        trim,
                        :state="validverfityState()",
                        v-model="mobileVerfityCode",
                        aria-describedby="input-live-help input-name-live-feedback",
                        placeholder="請輸入驗證碼",
                        class="rounded-0 bg-light border-black text-center mb-3"
                      )
                      b-form-invalid-feedback(
                        id="input-name-live-feedback"
                      )
                        span 簡訊驗證碼不可為空
                    .text-center
                      div(
                        v-if="verfityNowTime == 0"
                      )
                        button.btn.btn-remind.rounded-50.mt-2(
                          type="button",
                          @click="countDownHandler",
                          class="rounded-0 bg-light border-black text-center text-black btn-block"
                        )
                          i.fas.fa-redo.fa-md.arrorIcon.pr-1
                          span 重發驗證碼
                      div(
                        v-else
                      )
                        span.font-weight-bold {{ verfityNowTime }}
                        | 秒後可重發驗證碼
    .footer.bg-white.w-100.pb-4
      b-button(
        variant="primary",
        block,
        @click="nextStepHandler()",
        class="rounded-0 text-black border-gray"
      ) 確認
        //- .px-4
        //-   button.button.btn-block.button_clickCustom.button_clickCustom-outline-primary(
        //-     type="button",
        //-     @click="nextStepHandler()"
        //-   )
        //-     | 送出資料
        //-     i.fas.fa-arrow-alt-circle-right.fa-lg.arrorIcon

</template>

<script>
import StepComponent from '@/components/step/StepComponent.vue'; // 客製化進度條
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import VerifyComponent from '@/components/verify/VerifyComponent.vue'; // 驗證套件
import { SA_SIGN_UP_SUCCESS } from '@/router/sa/sign-up';

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

// 客製化身分證驗證
extend('mobile', {
  validate: (val) => {
    const MobileReg = /^(09)[0-9]{8}$/;
    return MobileReg.test(val);
  },
  message: '行動電話格式錯誤'
});

// 客製化驗證套件
extend('verify', {
  validate: (val) => {
    if (VerifyComponent.data.varifyAnswer === undefined) return true;
    return val === VerifyComponent.data.varifyAnswer ? true : false;
  },
  message: '驗證碼錯誤'
});

export default {
  name: 'SaSignUpIndex',
  components: {
    StepComponent,
    ValidationProvider,
    ValidationObserver,
    VerifyComponent
  },
  data() {
    return {
      nowStep: 1,
      firstType: true, // 第一次進來輸入資料
      userForm: {
        sa_name: null,
        saCode: null,
        mobile: null,
        verify: null
      },
      mobileVerfityCode: null,
      verfityTotalTime: 180,
      verfityNowTime: 0,
      verfityCanClick: true
    };
  },
  mounted() {
    const vm = this;
    // 檢查綁定狀態
    vm.$store.dispatch('sa_sign_up/checkBindingHandler')
      .then(() => {
        vm.$store.commit('toggleLoading', false);
      });
  },
  methods: {
    async nextStepHandler() {
      const vm = this;
      switch (vm.nowStep.toString()) {
      case '1':
        vm.nowStep = 2;
        break;
      case '2':
        vm.submitHandler();
        break;
      case '3':
        vm.mobileVerfityHandler();
        break;
      default:
        break;
      }
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      const isValid = await vm.$refs.userForm.validate();
      if (!isValid) {
        if (vm.userForm.sa_name === null) {
          vm.userForm.sa_name = '';
        }
        if (vm.userForm.saCode === null) {
          vm.userForm.saCode = '';
        }
        if (vm.userForm.mobile === null) {
          vm.userForm.mobile = '';
        }
        if (vm.userForm.verify === null) {
          vm.userForm.verify = '';
        }
        this.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位或格式輸入錯誤'
        });
      } else {
        // 因為客製化驗證 extend 可以判斷是不是輸入一樣驗證碼但抓不到值，
        // 會造成畫面顯示正確卻一直跳到 isValid，所以改成手動驗證。
        if (vm.userForm.verify !== vm.$refs.VerifyComponent.varifyAnswer) {
          this.$swal.fire({
            icon: 'error',
            title: '請填妥必填欄位或格式輸入錯誤'
          });
          return;
        }
        vm.countDownHandler();
        vm.nowStep = 3;
      }
    },
    // 送出手機驗證
    async mobileVerfityHandler() {
      const vm = this;
      const isValid = await vm.$refs.mobileVerfityForm.validate();
      if (!isValid) {
        if (vm.mobileVerfityCode === null) {
          vm.mobileVerfityCode = '';
        }
        if (!vm.mobileVerfityCode) {
          vm.$swal.fire({
            icon: 'error',
            title: '請填寫驗證碼'
          });
        }
      } else {
        vm.$swal.fire({
          title: '請稍候，\n表單送出中',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        // 驗證簡訊驗證碼並綁定
        vm.$store.dispatch('sa_sign_up/validateSmsAndBindHandler', {
          sa_name: vm.userForm.sa_name,
          mobile: vm.userForm.mobile,
          sa_code: vm.userForm.saCode,
          code: vm.mobileVerfityCode
        })
          .then(() => {
            this.$swal.close();
            vm.$router.push({
              name: SA_SIGN_UP_SUCCESS
            });
          });
      }
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      if (vm.userForm[key] !== null) {
        if (key === 'mobile') {
          const MobileReg = /^(09)[0-9]{8}$/;
          return MobileReg.test(vm.userForm[key]);
        }
        if (key === 'email') {
          const EmailReg = /^[^\s]+@[^\s]+\.[^\s]{2,3}$/;
          return EmailReg.test(vm.userForm[key]);
        }
        if (key === 'verify') {
          return vm.userForm.verify === vm.$refs.VerifyComponent.varifyAnswer ? true : false;
        }
        return this.userForm[key] ? true : false;
      }
      return null;
    },
    mobileState() {
      const vm = this;
      if (vm.userForm.mobile !== null) {
        const MobileReg = /^(09)[0-9]{8}$/;
        return MobileReg.test(vm.userForm.mobile);
      }
      return null;
    },
    validverfityState() {
      const vm = this;
      if (vm.mobileVerfityCode !== null) {
        return this.mobileVerfityCode ? true : false;
      }
      return null;
    },
    // 倒數驗證碼
    countDownHandler() {
      const vm = this;
      if (!vm.verfityCanClick) return;
      // 發送驗證碼
      vm.$store.dispatch('sa_sign_up/sendSmsValidateHandler', vm.userForm.mobile)
        .then(() => {
          vm.$snotify.success(null, '驗證碼已寄出');
          vm.verfityCanClick = false;
          vm.verfityNowTime = vm.verfityTotalTime;
          const clock = window.setInterval(() => {
            if (vm.verfityNowTime === 0) {
              window.clearInterval(clock);
              vm.verfityCanClick = true; // 這裡重新開啟
            } else {
              vm.verfityNowTime -= 1;
            }
          }, 1000);
        });
    },
    changeVerifyCodeHandler() {
      const vm = this;
      vm.$refs.VerifyComponent.changeVerifyCodeHandler();
    }
  }
};
</script>

<style>

</style>
